import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';

import InputText from "./InputText";
import OptionInput from "./OptionInput";
import DateInput from "../../generico/CampoFecha";
import MensajeLogin from '../../generico/Login/MensajeLogin';
import Popup from "react-popup";
import $ from "jquery";
import CabalTitulo from "./CabalTitulo"
import history from "../login/history";
import { splitImporte, agregarBarra, reemplazarBarra , normalizarMonto } from "../../generico/utils/FormatoInput";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AuthService from '../../../services/login/auth.service';

import pagoServicioServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";

export default class SicoopPaso1 extends Component {
  constructor(props) {
    super(props);
    // this.handleOK = this.handleOK.bind(this);
    this.validatePago = this.validatePago.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      formulario: undefined,
      tipoTrx: "",
      campos: [],
      camposRespuesta: [],
      parametersResponse:[],
      msgError: "",
      disableSgte: true,
      idOperacion:undefined,
      cantidadFacturas:undefined,
      paymentService:[],
      errors: {},
    };
    // if (this.props.codigoServicio === "55") {
    //   Popup.queue(this.notifiPopup("ATENCION", MENSAJE.TEXTO_SET));
    // }
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
              // window.location.reload();
              console.log('WINDOWS RELOAD');
            },
          },
        ],
      },
    });
  
  componentDidMount() {
    // sessionStorage.removeItem("servicio");
    // sessionStorage.removeItem("nombre");
    // sessionStorage.removeItem("img");
    // sessionStorage.removeItem("entidad");
    // sessionStorage.removeItem('networkParticipantCode');
    // sessionStorage.removeItem('codigoEntidad');
    this.obtenerFormularioV2();
    $('#btn-pago').attr('disabled', 'true');
    $('#btn-next').attr('disabled', 'true');
  }


  obtenerFormularioV2() {
    let data = {
      'paymentServiceId' : this.props.codigoServicio,
      'paymentEntityId' : this.props.entidadId,
      'paymentEntityName' : this.props.empresa,
      'paymentServiceName' : this.props.nombreServicio,
      'networkParticipantCode' : this.props.networkParticipantCode
    }
    let parameters = [];
    let parametersResponse= [];
    trackPromise(
      pagoServicioServiceV2.listarParametros( data )
      .then((response) => {
        if( response.status === 200 ){
          if( response.data.codigo === 0 ){
            if( response.data.datos.header.codRespuesta === '0'  ){
              let campos = response.data.datos.data.parameter;
              let tipoTrx = response.data.datos.data.tipoTrx;
              campos.forEach(element => {
                if( element.fieldType === 7 ){
                  switch (element.name) {
                    case 'Documento de identidad o RUC':
                      element.value = AuthService.getSocio().numeroCedula;
                      break;
                    case 'Nombre':
                      element.value = AuthService.getSocio().nombreCompleto.toUpperCase();
                      break;
                    case 'Email':
                      element.value = AuthService.getSocio().correoElectronico;
                      break;
                    default:
                      break;
                  }
                }
                parameters.push({
                  name: element.name,
                  label:element.label,
                  value: element.value,
                  fieldType:  element.fieldType,
                  notificationOrder: element.notificationOrder,
                  isAmount : element.isAmount
                });
              });
              parametersResponse = parameters;
              let idOperacion = response.data.datos.data.id;
              this.setState({parametersResponse:parametersResponse,campos:campos,tipoTrx:tipoTrx,idOperacion:idOperacion});
            }else{
              Popup.queue(this.notifiPopup("Error", 'Error al Listar Parámetros. Respuesta Sicoop: '+response.data.datos.header.txtRespuesta));
            }
          }else{
            Popup.queue(this.notifiPopup("Error", 'Error al listar Parámetros. Respuesta Sicoop: '+response.data.datos.header.txtRespuesta));
          }
        }else{
          Popup.queue(this.notifiPopup("Error", 'Ha ocurrido un error al listar los parámetros. Por favor intente más tarde'));
        }
      }
      )
      .catch((error)=>{
        Popup.queue(this.notifiPopup("Error", 'Ha ocurrido un error con el servicio de Listar Parámetros. Por favor intente nuevamente más tarde.'));
        console.log(error);
        this.volver();
        return;
      })
    );

  }


  inputValue = (dataFromChild, nombre, error, descripcionError, tipo, label, requerido, min,validacion) => {
    let parametersResponse = this.state.parametersResponse;
    let errors = { ...this.state.errors };
    if (error) {
      errors[nombre] = descripcionError;
      this.setState({ msgError: descripcionError, disableSgte: true, errors });
      return;
    } else {
      delete errors[nombre];
      this.setState({ msgError: '', disableSgte: false, errors });
    }

    if (dataFromChild !== "") {
      let datoChild = dataFromChild;
      if (tipo === "MONEY")
        datoChild = splitImporte(dataFromChild);
      if (tipo === "DATE")
        datoChild = reemplazarBarra(dataFromChild);
      parametersResponse.forEach(element => {
        if (element.name === nombre) {
          element.value = datoChild;
        }
      });
      this.setState({ parametersResponse });
    }
  };


  validatePagar = (elemento) => {

    if (!$.validator || typeof $.validator.setDefaults !== 'function' || typeof $("#idSicoopPaso1").validate !== 'function') {
      this.validatePago();
      return;
    }

    $.validator.setDefaults({
      submitHandler: () => {

        this.validatePago();
      }
    });
    const { errors } = this.state;
    if (Object.keys(errors).length > 0) {
      this.setState({ msgError: 'Campos Vacíos!', disableSgte: true, errors });
      return;
    } else {
      this.setState({ msgError: '', disableSgte: false, errors: {} });
      this.validatePago();
    }
  };



  validateContinuar = () => {
    if (!$.validator || typeof $.validator.setDefaults !== 'function' || typeof $("#idSicoopPaso1").validate !== 'function') {
      this.validateSeguir();
      return;
    }

    $.validator.setDefaults({
      submitHandler: () => {
        this.validateSeguir();
      }
    });
    $("#idSicoopPaso1").submit(function (e) {

      e.preventDefault();
    }).validate({

      errorElement: "span",
      showErrors: function (errorMap, errorList) {
        $(".is-invalid").each(function () {
          this.classList.remove("is-invalid");
        });

        if (errorList[0] != null) {
          errorList[0].element.classList.add("is-invalid")
          var errorActual = errorList[0].message
          if (errorList[0].method === "required")
            errorActual = "Campo Requerido"
          if (errorList[0].method === "minlength")
            errorActual = "Por favor, ingrese al menos de " + errorList[0].element.minLength + " caracteres"
          if (errorList[0].method === "maxlength")
            errorActual = "El tamaño máximo es de " + errorList[0].element.maxLength + " caracteres"
          $(".form-validate").html(errorActual);
          $('#btn-next').attr('disabled', 'true');
        }
      }
    });

  };

  verificarTipo(elemento) {
    if (elemento.fieldType === 7) return;
    let validacion = elemento.validationRegexp;
    if (validacion && validacion.trim() !== '' && validacion !== null && validacion !== 'null') {
      if (validacion.startsWith('/') && validacion.endsWith('/')) {
        validacion = validacion.slice(1, -1);
      }
      while (validacion.includes('\\A') || validacion.includes('\\z')) {
        validacion = validacion.replace('\\A', '^');
        validacion = validacion.replace('\\z', '$');
      }
    }
    elemento.validationRegexp = validacion;
    const { errors } = this.state;
    if (elemento.type === "OPTION") {
      if (elemento.required === "true") {
        return (
          <div className="form-group">
            <OptionInput label={elemento.label} name={elemento.name}
              required={elemento.required} options={elemento.options} title={elemento.title}
              editable={elemento.editable} hidden={elemento.hidden}
              inputValue={this.inputValue.bind(this)} value={elemento.value}
            />
            {errors[elemento.name] && <span className="invalid-feedback d-block">{errors[elemento.name]}</span>}
          </div>
        );
      } else {
        return (
          <div className="form-group">
            <OptionInput label={elemento.label} name={elemento.name}
              options={elemento.options} title={elemento.title}
              editable={elemento.editable} hidden={elemento.hidden}
              inputValue={this.inputValue.bind(this)} value={elemento.value}
            />
            {errors[elemento.name] && <span className="invalid-feedback d-block">{errors[elemento.name]}</span>}
          </div>
        );
      }
    }
    if (elemento.format === "DATE") {
      if (elemento.required === "true") {
        return (
          <div className="form-group">
            <DateInput name={elemento.name} size={elemento.size} title={elemento.title} hidden={elemento.hidden}
              editable={elemento.editable} type={elemento.type} label={elemento.label} minValue={elemento.minValue}
              maxValue={elemento.maxValue} minLength={elemento.minLength} maxLength={elemento.maxLenght} format={elemento.format}
              required={elemento.required} nullable={elemento.nullable} debitable={elemento.debitable} value={agregarBarra(elemento.value)}
              inputValue={this.inputValue.bind(this)}
            />
            {errors[elemento.name] && <span className="invalid-feedback d-block">{errors[elemento.name]}</span>}
          </div>
        );
      } else {
        return (
          <div className="form-group">
            <DateInput name={elemento.name} size={elemento.size} title={elemento.title} hidden={elemento.hidden}
              editable={elemento.editable} type={elemento.type} label={elemento.label} minValue={elemento.minValue}
              maxValue={elemento.maxValue} minLength={elemento.minLength} maxLength={elemento.maxLenght} format={elemento.format}
              nullable={elemento.nullable} debitable={elemento.debitable} value={agregarBarra(elemento.value)}
              inputValue={this.inputValue.bind(this)}
            />
            {errors[elemento.name] && <span className="invalid-feedback d-block">{errors[elemento.name]}</span>}
          </div>
        );
      }
    } else {
      return (
        <div className="form-group">
          <InputText
            name={elemento.name}
            size={elemento.size ? elemento.size : 20}
            title={elemento.title}
            hidden={elemento.hidden}
            editable={elemento.editable}
            type={elemento.type}
            label={elemento.label}
            minValue={elemento.minValue}
            maxValue={elemento.maxValue}
            minLength={elemento.minLength}
            maxLength={elemento.maxLenght}
            format={elemento.format}
            required={elemento.required}
            nullable={elemento.nullable}
            debitable={elemento.debitable}
            inputValue={this.inputValue.bind(this)}
            value={elemento.value}
            validationRegexp={elemento.validationRegexp}
            errorMessage={elemento.errorMessage}
            hint={elemento.hint}
          />
          {errors[elemento.name] && <span className="invalid-feedback d-block">{errors[elemento.name]}</span>}
        </div>
      );
    }
  }

  validateSeguir = (e) => {
    // let cantidadParametros = this.state.parametersResponse.length;
    let campoVacio = false;
    this.state.parametersResponse.forEach(element => {
      if( element.value === undefined || element.value.trim() === '' ){
        $(`input[name="${element.name}"]`).css({border:"2px solid #dd5144"});
        campoVacio = true;
        this.setState({msgError:'Campos Vacíos!'});
      }
    });
    if( campoVacio ){
      return;
    }else{
      this.props.respuestaPaso1(this.state.idOperacion,JSON.parse(JSON.stringify(this.state.parametersResponse)), "SI", this.state.tipoTrx);
      //  console.log("FORMULARIO INGRESADO " + JSON.stringify(this.state.campos))
      this.nextStep.click();
    }

  };



  validatePago() {
    if( this.state.buscar === undefined ){
      let montoPagar = 0;
      if( this.state.tipoTrx === 'PAGO' ){
        this.state.parametersResponse.forEach(element => {
          if( element.isAmount ){
            montoPagar = parseInt(normalizarMonto(element.value));
          }
          this.state.paymentService.push({
            name : element.name,
            label: element.label,
            value : element.value,
            fieldType: element.fieldType ,
            notificationOrder : element.notificationOrder
          });         
        });
      }else{
        this.state.parametersResponse.forEach(element => {
          if( element.isAmount ){
            montoPagar = parseInt(normalizarMonto(element.value));
          }
        });
      }
      if( this.props.network === 'INFONET' ){
        let comision = undefined;
        let data = {
          id : this.state.idOperacion,
          amount : montoPagar,
          parameter : this.state.parametersResponse
        }
        trackPromise(
          pagoServicioServiceV2.obtenerComision(data)
          .then( response =>{
            if( response.status === 200 ){
              if( response.data.datos.header.codRespuesta === '0' ){
                comision = response.data.datos.data.commission;
                // let montoTotalPago = montoPagar + parseInt(comision);
                // console.log({MONTO_A_PAGAR:montoTotalPago});
                this.props.respuestaPaso1(this.state.idOperacion,this.state.parametersResponse, "SI", this.state.tipoTrx, this.state.campos,montoPagar,this.state.paymentService,comision);
                this.setState({ msgError: "",buscar:this.props.buscar});
                this.lastStep.click();
              }else{
                Popup.queue(this.notifiPopup("Error",response.data.datos.header.txtRespuesta ));
              }
            }else{
              Popup.queue(this.notifiPopup("Error",'Error al obtener la comisión. Intente nuevamente más tarde.' ));
            }
          })
        );        
      }else{
        this.props.respuestaPaso1(this.state.idOperacion,this.state.parametersResponse, "SI", this.state.tipoTrx, this.state.campos,montoPagar,this.state.paymentService,0);
        this.setState({ msgError: "",buscar:this.props.buscar});
        this.lastStep.click();
      }
      
    }

  };


  volver = (e) => {

    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
    window.location.reload();
  }

  handleEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.tipoTrx === "CONSULTA") {
      this.validateContinuar();
    } else {
      this.validatePagar();
    }
  }

  render() {
    if (this.props.currentStep !== 1) { // Prop: The current step
      return null
    }
    var campo = []
    // console.log("RECIBE PARA MOSTRAR "+JSON.stringify(this.props.formulario))
    if (this.props.formulario === undefined)
      campo = this.state.campos
    else
      campo = this.props.formulario
    // console.log("VA A MOSTRAR "+JSON.stringify(campo))
    return (

      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <div className="steps clearfix" style={{ marginBottom: 5 }}>
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">{this.props.nombreServicio}</span>

                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <CabalTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr />
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <div className="form-validate"></div>
          </div>
        </div>


        <form id="idSicoopPaso1" onKeyDown={this.handleEnter} onSubmit={this.handleSubmit}>
          {/******************* LOGICA PASOS ***********************/}
          <div className="row justify-content-md-center">
            <div className="col-md-6">

              {campo.map(elemento =>
                this.verificarTipo(elemento)
              )
              }

            </div>
            {this.state.msgError && (<MensajeLogin
              tipo="ERROR"
              mensaje={this.state.msgError} />

            )}

          </div>
          <hr />
          <div className="row">
            <div className="col-lg-8 col-md-6"></div>
            <div className="col-lg-2 col-md-3 btn-consulta">
            <button type="button" className="btn btn-cu-quintary" onClick={this.volver}>
            <FontAwesomeIcon icon={faArrowLeft} />  Volver</button>
            </div>
            <div className="col-lg-2 col-md-3">
            {this.state.tipoTrx === "CONSULTA" ?
              <button id="btn-next"
                type="button"
                disabled = {this.state.disableSgte}
                className="btn btn-cu-primary" onClick={this.validateContinuar}>Continuar <FontAwesomeIcon icon={faArrowRight} /></button>
              : <button id="btn-pago"
              type="button"
              disabled = {this.state.disableSgte}
                className="btn btn-cu-primary" onClick={this.validatePagar} >Pagar <FontAwesomeIcon icon={faArrowRight} /> </button>
            }
            </div>
          </div>
         
          <button
            type="button"
            hidden
            ref={(a) => (this.nextStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
          ></button>

          <button
            type="button"
            hidden
            ref={(a) => (this.lastStep = a)}
            className="btn btn-cu-primary"
            onClick={() => this.props.goToStep(3)}

          ></button>


        </form>
      </div>

    );
  }
}